import Swal from 'sweetalert2';
import i18n from 'i18next';
 
type ConfirmationCallback = () => void;

const showConfirmation = (message: string, callback: ConfirmationCallback) => {
  Swal.fire({
    title: i18n.language === 'en' ? 'Confirmation' : 'تأكيد',
    text: message,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    // cancelButtonText: i18n.language === 'en' ? 'Cancel' : 'إلغاء',
    // confirmButtonText: i18n.language === 'en' ? 'Yes' : 'نعم',

    cancelButtonText:
      i18n.language === 'en'
        ? '<i class="fas fa-lg fa-times-circle me-2"></i> Cancel'
        : '<i class="fas fa-lg fa-times-circle me-2"></i> إلغاء',
    confirmButtonText:
      i18n.language === 'en'
        ? '<i class="fas fa-check-circle me-2"></i> Yes'
        : '<i class="fas fa-check-circle me-2"></i> نعم',

    background: 'var(--bs-body-bg)',
    iconColor: 'var(--bs-theme)',
    color: 'var(--bs-heading-color)',
    customClass: {
      container: 'border',
      popup: 'border border-theme border-3 rounded-5'
    }
  }).then(result => {
    if (result.isConfirmed) {
      callback();
    }
  });
};

export default showConfirmation;
